/*
    FloatInput1 is common component for taking input
*/

import React from 'react';
import Props from 'prop-types';
import {textLastColor} from '../../../Utils/warning';

class FloatInput1 extends React.Component {


    state = {
        value: ''
    }



    componentDidMount() {
        if (this.props.handleRef) {
            this.props.handleRef(this);     // passing the reference of `this`
        }
    }

    getValue() {
        return this.state.value;
    }



    setValue(i) {
        this.setState({
            value:''
        },()=>{
            this.setState({
                ...this.state,
                value:i
            })
        })
    }

    render() {
        return (
            <div style={{
                marginBottom: 20,
                ...this.props.style
            }}>
                <p style={{
                    fontSize: 12,
                }}>{textLastColor(this.props.title)}</p>
                <div className="flex flex-v-center flex-h-center" style={{
                    backgroundColor: '#fff',
                    border:'1px solid #dedede',
                    borderRadius: 12,
                    height: 50,
                    marginTop: 10,
                    fontSize: '12px',
                    ...this.props.containerStyle
                }}   
               >
                    <input  type={this.props.type} onChange={e => {
                        if (this.props.onChange) {
                            this.props.onChange(e.target.value);
                        }

                        if (this.props.isNumber) {
                            let regex = /^[0-9\b]+$/;
                            if (regex.test(e.target.value) || e.target.value === "") {
                                this.setState({
                                    value: e.target.value
                                })
                            }
                        } else {
                            this.setState({
                                value: e.target.value
                            })
                        }
                    }} value={this.state.value}
                        placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                      
                        style={{
                            width: '98%',
                            height: '90%',
                            padding: '10px',
                            border: 'none',
                            color: 'var(--input-color)',
                            fontSize:16
                        }}
                        maxLength={this.props.maxLength ? this.props.maxLength : 250}

                    />
                </div>
            </div>
        )
    }
}



FloatInput1.propsTypes = {
    title: Props.string
}

FloatInput1.defaultProps = {
    placeholder: "Enter the values here",
    type: 'text',
    disable: false,
    isNumber: false
}

export { FloatInput1 }
